import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

@Injectable()
export class RecentlyAddedProjectsDataService {
  constructor(
    private readonly http: HttpClient,
    private readonly splashscreenService: SplashscreenService
  ) { }

  getProjects(days = 14): Observable<any[]> {
    return this.http.get<any[]>('/api/recentlyaddedprojects', { params: { days } as any }).pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }
}
